import React from 'react';
import { Divider, useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from '@michelin/central-provider';
import { AutocompleteSelect } from 'components/SearchSelector';
import { AdditionalServicesType, UFOPart } from 'types/UFOTypes';
import { BREAKPOINT } from 'utils/responsivenessUtils';

const autoCompleteFilterOptions = (options, search) =>
  options.filter(
    (option) =>
      option.value?.toLowerCase().includes(search.inputValue.toLowerCase()) ||
      option.label?.toLowerCase().includes(search.inputValue.toLowerCase()),
  );

interface ProductAutocompleteProps {
  customParts: UFOPart[];
  filteredServices: AdditionalServicesType[];
  onChange: (value: UFOPart | AdditionalServicesType | undefined) => void;
  loading: boolean;
  parts: UFOPart[];
}
export const ProductAutocompleteComponent = (props: ProductAutocompleteProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down(BREAKPOINT));

  const { parts, loading, onChange, filteredServices, customParts } = props;

  const autoCompleteOptions = [
    ...parts.map((p) => ({ value: p.mspn, label: p.tire_title, data: p })),
    ...filteredServices.map((s) => ({ value: s.mspn, label: s.description, data: s })),
    ...customParts.map((p) => ({ value: p.mspn, label: p.tire_title, data: p })),
  ];

  const autoCompleteRenderOption = ({ label }: { label?: string | number }) =>
    !label ? null : (
      <div style={{ width: '100%' }}>
        <div style={{ margin: 16, minWidth: 250 }}>{t(`${label}`)}</div>
        <Divider
          id="selectTiresAndPArtsDividerB"
          style={
            mobileView
              ? {
                  width: '100%',
                  marginTop: 16,
                  background: theme.palette.primary.main,
                }
              : { width: '100%', marginTop: 16 }
          }
        />
      </div>
    );

  return (
    <AutocompleteSelect<UFOPart | AdditionalServicesType>
      noOptionsText={t('Search by product name, part number, etc')}
      value={null}
      loading={loading}
      placeholder={t('Search by product name, part number, etc')}
      label={t('Search to filter results')}
      onChange={(_, value) => {
        onChange(value.data);
      }}
      options={autoCompleteOptions}
      filterOptions={autoCompleteFilterOptions}
      renderOption={autoCompleteRenderOption}
    />
  );
};
